import React from 'react'

export const TabContainer = ({ children }) => {
    return (
        <ul className='flex mt-2 gap-1 text-sm font-medium text-center text-gray-500 border-b-4 border-white dark:border-gray-800/60 dark:text-gray-400 overflow-auto'>
            {children}
        </ul>
    )
}
